import React from 'react';

const IconScotland = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 512 356.18"
      {...props}
    >
      <path
        fill="#0065BD"
        d="M28.137 0H483.86C499.337 0 512 12.663 512 28.14v299.9c0 15.477-12.663 28.14-28.14 28.14H28.137C12.663 356.18 0 343.517 0 328.04V28.14C0 12.663 12.663 0 28.137 0z"
      />
      <path
        fill="#fff"
        d="M28.737 0l227.241 136.349L483.252 0h.608C499.337 0 512 12.663 512 28.14v38.063L325.528 178.091 512 289.981v38.059c0 15.477-12.663 28.14-28.14 28.14h-.608L255.978 219.834 28.737 356.18h-.6C12.663 356.18 0 343.517 0 328.04v-38.061l186.457-111.888L0 66.205V28.14C0 12.663 12.663 0 28.137 0h.6z"
      />
    </svg>
  );
};

export default IconScotland;
